function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#FFD561",
  x: 0,
  y: 0,
  width: 73,
  height: 73,
  rx: 22
}), /*#__PURE__*/React.createElement("g", {
  id: "right",
  transform: "translate(37.506697, 27.026605) rotate(51.000000) translate(-37.506697, -27.026605) translate(25.006697, 14.526605)",
  fill: "#DC7B53",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8134361,8.32702364 C9.41277058,8.40286925 2.64276575,15.2346455 2.64322167,23.6356555 C2.64322167,24.32125 2.08743757,24.8770343 1.40184315,24.8770343 C0.716248724,24.8770343 0.160456974,24.32125 0.160456974,23.6356555 C0.151485868,13.8582512 8.04064259,5.90919184 17.8178327,5.84421429 L19.4708316,7.08393793 L17.8134361,8.32702364 Z M17.0432125,13.0425562 L23.6638979,8.07704098 C23.9764843,7.84260116 24.1604493,7.47467098 24.1604493,7.08393793 C24.1604493,6.69320488 23.9764843,6.32527471 23.6638979,6.09083488 L17.0432125,1.12531963 C16.688411,0.859218465 16.2185977,0.802615225 15.8107467,0.976831798 C15.4028956,1.15104837 15.1189691,1.52961712 15.0659196,1.96993485 C15.01287,2.41025258 15.1987568,2.84542457 15.5535583,3.11152573 L20.8501066,7.08393793 L15.5535583,11.0563501 C15.0050827,11.4677069 14.8939259,12.2458048 15.3052826,12.7942805 C15.7166392,13.3427561 16.4947369,13.453913 17.0432125,13.0425562 L17.0432125,13.0425562 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.0344361,40 L63.0344361,40 C64.6912904,40 65.5210956,40.8726866 64.8878579,41.9492 L62.2125086,46.4973332 C61.5792709,47.5738467 59.7227845,48.4465332 58.0659303,48.4465332 L14.0659303,48.4465332 C12.409076,48.4465332 11.5792709,47.5738467 12.2125086,46.4973332 L14.8878579,41.9492 C15.5210956,40.8726866 17.3775819,40 19.0344361,40 Z",
  id: "Rectangle",
  stroke: "#75318C",
  strokeWidth: 2,
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#75318C",
  transform: "translate(61.393932, 44.353452) rotate(34.000000) translate(-61.393932, -44.353452) ",
  x: 60.3939321,
  y: 39.8534516,
  width: 2,
  height: 9
})));

function SvgTabletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/tablet-icon.218541db.svg";
export { ForwardRef as ReactComponent };